import {
  isAbsorbableReassociateEndpoint,
  type HarReassociateRow,
} from './har-reassociate-identity';

export type EndpointUriOption = {
  value: string;
  label: string;
  method: string;
  host: string;
  path: string;
};

export function toEndpointUriLabel({ path }: { path: string }): string {
  const uri = path.trim();

  return uri.length > 0 ? uri : '/';
}

export function toEndpointUriOption({
  id,
  path,
  method,
  host,
}: {
  id: string;
  path: string;
  method: string;
  host: string;
}): EndpointUriOption {
  const normalizedPath = path.trim() || '/';

  return {
    value: id,
    label: toEndpointUriLabel({ path: normalizedPath }),
    method,
    host,
    path: normalizedPath,
  };
}

export function endpointUriMatchesQuery({
  uri,
  query,
}: {
  uri: string;
  query: string;
}): boolean {
  const needle = query.trim().toLowerCase();

  if (!needle) {
    return true;
  }

  return uri.toLowerCase().includes(needle);
}

export function filterEndpointUriOptions({
  items,
  query,
  rows,
}: {
  items: readonly EndpointUriOption[];
  query: string;
  rows?: readonly HarReassociateRow[];
}): EndpointUriOption[] {
  return items.filter((item) => {
    if (!endpointUriMatchesQuery({ uri: item.label, query })) {
      return false;
    }

    if (!rows) {
      return true;
    }

    return isAbsorbableReassociateEndpoint({
      rows,
      endpoint: {
        method: item.method,
        host: item.host,
        path: item.path,
      },
    });
  });
}

export function withSelectedEndpointOption({
  items,
  selectedId,
  catalog,
}: {
  items: EndpointUriOption[];
  selectedId: string;
  catalog: readonly EndpointUriOption[];
}): EndpointUriOption[] {
  if (!selectedId || items.some((item) => item.value === selectedId)) {
    return items;
  }

  const selected = catalog.find((item) => item.value === selectedId);

  if (!selected) {
    return items;
  }

  return [selected, ...items];
}
